<template>
  <li class="card-elm-item phone-info">
    <i class="icon icon-cards-phone"
      ><span class="sr-only">Téléphone</span></i
    >
    <span>
      {{ phone }}
    </span>
  </li>
</template>

<script>
export default {
  props: {
    phone: { type: String, default: '' },
  },
};
</script>
